<div class="flex flex-col">
  <div class="flex flex-col justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Name</mat-label>
      <input matInput placeholder="Survey title" [(ngModel)]="data.input.name"
             particleAnalytics
             analyticsCategory="add-survey-dialog"
             analyticsAction="Survey-title" required>
    </mat-form-field>
  </div>
  <div class="flex flex-col justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Description</mat-label>
      <textarea matInput type="text" [(ngModel)]="data.input.description"
                placeholder="Survey Description" rows="5">
              </textarea>
    </mat-form-field>
  </div>
</div>


